import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmployeesRoutingModule } from './employees-routing.module';
import { CreateEmployeeComponent } from './create-employee/create-employee.component';
import { SharedModule } from 'app/shared/shared.module';
import { EmployeeDetailComponent } from './employee-detail/employee-detail.component';
import { EmployeesTableComponent } from './employees-table/employees-table.component';
import { JobsTableComponent } from './jobs-table/jobs-table.component';
import { CreateJobComponent } from './create-job/create-job.component';
import { CreateFunctionsComponent } from './create-functions/create-functions.component';
import { CreateProcedureComponent } from './create-procedure/create-procedure.component';
import { AssignJobComponent } from './assign-job/assign-job.component';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { CreateReportComponent } from './create-report/create-report.component';
import { CreateCouncilComponent } from './create-council/create-council.component';

@NgModule({
  declarations: [
    CreateEmployeeComponent,
    EmployeeDetailComponent,
    EmployeesTableComponent,
    JobsTableComponent,
    CreateJobComponent,
    CreateFunctionsComponent,
    CreateProcedureComponent,
    AssignJobComponent,
    CreateReportComponent,
    CreateCouncilComponent
  ],
  imports: [
    CommonModule,
    EmployeesRoutingModule,
    SharedModule,
    NgbTypeaheadModule
  ]
})
export class EmployeesModule { }
